// @flow
import React from 'react';
import classNames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { t } from 'Src/i18n';

type Props = {
  extendedDataset?: boolean,
  departure?: ?string,
  transportIcon: IconName,
};

export const TransportSummary = (props: Props) => {
  const { departure, extendedDataset = false, transportIcon } = props;
  const noTransportIcon = ICONS.NO_TRANSPORT;

  return (
    <div
      className={classNames('PackagePriceSummary-section', {
        'PackagePriceSummary-section--extended': extendedDataset,
      })}
    >
      <Icon
        color={COLORS.BLUE}
        name={departure ? transportIcon : noTransportIcon}
        className="PackagePriceSummary-icon"
        width="1.875rem"
        hasRtl
      />
      {departure ? (
        <span>
          {t('common.transport.from')}{' '}
          <span className="PackagePriceSummary-departure">{departure}</span>
        </span>
      ) : (
        t('booking.priceDetails.packagePrice.noTransport')
      )}
    </div>
  );
};
